import React from 'react'
import '../Project.css';
import Image1 from '../../Gemco-Website-Images/projects/Mobility_Pavilion.webp';

const Project_one = () => {

  return (
    <>

      <div className='project_1_work' id="workBanner">

        <div className="container project_our_work">

          <div className="heading">
            <h1>Mobility Pavilion — Expo 2020 Dubai</h1>
          </div>

          <hr></hr>
          <div className='project_section'>
            <div className="project_section_content">
              <h1 className="project_scope">Scope of Work</h1>
              <p>One of three landmark thematic pavilions at Expo 2020 Dubai, dedicated to the future of mobility and transportation. The
                pavilion featured a large-scale, technically complex MEP infrastructure supporting fully immersive visitor experiences over the
                six-month global event.</p>
              <p>MAIN CONTRACTOR : -</p>
              <p>MEP CONTRACTOR : Al Futtaim Engineering</p>
              <p>GEMCO SCOPE OF WORKS : Major CHW and LPG works — full plant room installations
                and entire distribution network</p>
              {/* <h2 className="project_years">2014 – 2022</h2> */}
            </div>
            <div className='project_1_card'>
              <img className="project_one_image" width="500" height="300" src={Image1} alt="Project" />
            </div>
          </div>
        </div>
      </div>

    </>

  )
}

export default Project_one